/** Role 1 learner with no organization — self-registered / standalone user. */
export const isIndividualLearner = (user) =>
  Boolean(user) &&
  parseInt(user.role, 10) === 1 &&
  !user.organization_id;

/** Role 1 learner assigned to an organization. */
export const isOrgLearner = (user) =>
  Boolean(user) &&
  parseInt(user.role, 10) === 1 &&
  Boolean(user.organization_id);
